export async function exportGridToWebp({ rows, cols, cellSize, placed, aspect = 'tcg', transparent = false }, quality = 0.92, progressCallback = null) {
  const cellHeight = aspect === '1:1'
    ? cellSize
    : aspect === 'tcg'
      ? Math.round(cellSize * 1040 / 745)
      : Math.round(cellSize * 4 / 3);
  const width = cols * cellSize;
  const height = rows * cellHeight;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  // Background (white or transparent)
  if (!transparent) {
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
  }

  const entries = Object.entries(placed);
  const total = entries.length;
  let completed = 0;

  const drawPromises = entries.map(async ([key, item], index) => {
    const [rStr, cStr] = key.split('-');
    const r = parseInt(rStr, 10);
    const c = parseInt(cStr, 10);
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const x = c * cellSize;
        const y = r * cellHeight;
        ctx.drawImage(img, x, y, cellSize, cellHeight);
        completed++;
        if (progressCallback) {
          progressCallback({
            active: true,
            step: `Rendering image ${completed}/${total}...`,
            percent: 20 + Math.floor((completed / total) * 45)
          });
        }
        resolve();
      };
      img.onerror = reject;
      img.src = item.src;
    });
  });

  await Promise.all(drawPromises);

  return new Promise((resolve) => {
    if (progressCallback) {
      progressCallback({ active: true, step: 'Finalizing...', percent: 70 });
    }
    canvas.toBlob((blob) => {
      resolve(blob);
    }, 'image/webp', quality);
  });
}

export function downloadBlob(blob, filename = 'grid.webp') {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function exportGridToWebpDataUrl({ rows, cols, cellSize, placed, aspect = 'tcg' }, quality = 0.92) {
  const cellHeight = aspect === '1:1'
    ? cellSize
    : aspect === 'tcg'
      ? Math.round(cellSize * 1040 / 745)
      : Math.round(cellSize * 4 / 3);
  const width = cols * cellSize;
  const height = rows * cellHeight;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);

  const drawPromises = Object.entries(placed).map(async ([key, item]) => {
    const [rStr, cStr] = key.split('-');
    const r = parseInt(rStr, 10);
    const c = parseInt(cStr, 10);
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const x = c * cellSize;
        const y = r * cellHeight;
        ctx.drawImage(img, x, y, cellSize, cellHeight);
        resolve();
      };
      img.onerror = reject;
      img.src = item.src;
    });
  });

  await Promise.all(drawPromises);

  return canvas.toDataURL('image/webp', quality);
}
